module.exports = __webpack_public_path__ + "img/ztxx.a07ea22f.svg";